import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {AgencyHeader} from "./AgencyHeader";
import {AgencyTabs} from "./AgencyTabs";
import {ClientAdAccountAndStoresList, VIEW_MODE_AGENCY_ACCOUNTS} from "../client/ad_accounts/ClientAdAccountAndStoresList";


export class AgencyAdAccountsAndStoresContent extends Component {
    constructor(props) {
        super(props);
        this.handleClientAdAccountRemove = this.handleClientAdAccountRemove.bind(this);
        this.handleClientAdAccountSuccessfullyEdited = this.handleClientAdAccountSuccessfullyEdited.bind(this);
        this.handleClientAdAccountSuccessfullyAdded = this.handleClientAdAccountSuccessfullyAdded.bind(this)
        this.handleClientStoreSuccessfullyEdited = this.handleClientStoreSuccessfullyEdited.bind(this);
        this.handleClientStoreSuccessfullyAdded = this.handleClientStoreSuccessfullyAdded.bind(this)
        this.handleGiveAccessClientAdAccountSuccessfully = this.handleGiveAccessClientAdAccountSuccessfully.bind(this)
        this.handleSnoozeForever = this.handleSnoozeForever.bind(this)
        this.handlePlatformToggle = this.handlePlatformToggle.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleClearFilters = this.handleClearFilters.bind(this)
        this.handleStatusToggle = this.handleStatusToggle.bind(this)
        this.searchDebounceTimer = null;
        this.state = {
            'clientAdAccounts': null,
            'clientStores': null,
            'unlinkedAdAccounts': null,
            'ignoredAdAccounts': null,
            'name': '',
            'isSaving': false,
            'accessManagementEnabled': null,
            'selectedPlatforms': new Set(),
            'selectedStatuses': new Set(['linked', 'unlinked', 'ignored']),
            'searchQuery': '',
            'debouncedSearchQuery': ''
        };
    }

    UNSAFE_componentWillMount() {
        this.updateAgencyData();
        this.updateAccessManagementEnabled();
    }

    handleClientAdAccountSuccessfullyEdited(clientAdAccountId) {
        this.updateAgencyData();
        this.props.afterSuccessfulClientAdAccountEdited(clientAdAccountId);
    }

    handleClientStoreSuccessfullyEdited(clientStoreId) {
        this.updateAgencyData();
        this.props.afterSuccessfulClientStoreEdited(clientStoreId);
    }

    handleSnoozeForever(adAccountId) {
        this.setIsSaving(true);

        const adAccountSnoozeURL = this.getAdAccountSnoozeUnlinkedURL(adAccountId)
        new APIClient(adAccountSnoozeURL).call('GET').then((data) => {
            this.setIsSaving(false);

            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.updateAgencyData();
            }
        })
    }

    handleClientAdAccountSuccessfullyAdded(clientAdAccountId) {
        this.updateAgencyData();
        this.props.afterSuccessfulClientAdAccountSubmit(clientAdAccountId);
    }

    handleClientStoreSuccessfullyAdded(clientStoreId) {
        this.updateAgencyStoresData();
        this.props.afterSuccessfulClientStoreSubmit(clientStoreId);
    }

    handleGiveAccessClientAdAccountSuccessfully(clientAdAccountId) {
        this.props.afterSuccessfulGiveAccessClientAdAccountSubmit(clientAdAccountId);
    }

    setIsSaving(new_value, callback){
        this.setState({
            ...this.state,
            'isSaving': new_value
        }, callback);
    }

    // FEDE: Esto se repite en ClientConfigurationContent
    handleClientAdAccountRemove(clientAdAccountId) {
        this.setIsSaving(true, () => {
            const removeAdAccountURL = this.getClientAdAccountRemoveURL(clientAdAccountId)
            new APIClient(removeAdAccountURL).call('GET').then((data) => {
                this.setIsSaving(false, () => {
                    if (data.status === 'ERROR') {
                        alert(data.error_message);
                    } else if (data.status === 'OK') {
                        this.updateAgencyData();
                    }
                });
            });
        });
    }

    updateAgencyAdAccountsDataURL() {
        return API_URL + 'agency/ad-accounts/';
    }

    updateAccessManagementEnabledURL() {
        return API_URL + 'agency/subscription/';
    }

    updateAccessManagementEnabled() {
        new APIClient(this.updateAccessManagementEnabledURL()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY' || data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    accessManagementEnabled: data.data.access_management
                });
            }
        })
    }

    updateAgencyData() {
        this.setIsSaving(true, () => {
            new APIClient(this.updateAgencyAdAccountsDataURL()).call('GET').then((data) => {
                this.setIsSaving(false, () => {
                if (data.status === 'ERROR') {
                    alert(data['error_message']);
                } else if (data.status === 'OK') {
                    this.setState({
                        ...this.state,
                        'clientAdAccounts': data.data.client_ad_accounts,
                        'unlinkedAdAccounts': data.data.unlinked_ad_accounts,
                        'ignoredAdAccounts': data.data.ignored_ad_accounts,
                        'clientStores': data.data.client_stores,
                        'channels': data.data.channels
                    });
                }
            });
            });
        });
    }

    getClientAdAccountRemoveURL(clientAdAccountId) {
        return `${API_URL}client/ad_account/${clientAdAccountId}/remove`
    }

    getAdAccountSnoozeUnlinkedURL(adAccountId) {
        return `${API_URL}agency/ad_accounts/${adAccountId}/snooze-unlinked`
    }

    handlePlatformToggle(channel) {
        this.setState(prevState => {
            const newSet = new Set(prevState.selectedPlatforms);
            if (newSet.has(channel)) {
                newSet.delete(channel);
            } else {
                newSet.add(channel);
            }
            return {selectedPlatforms: newSet};
        });
    }

    handleSearchChange(query) {
        this.setState({searchQuery: query});
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = setTimeout(() => {
            this.setState({debouncedSearchQuery: query});
        }, 200);
    }

    handleClearFilters() {
        clearTimeout(this.searchDebounceTimer);
        this.setState({
            selectedPlatforms: new Set(),
            selectedStatuses: new Set(['linked', 'unlinked', 'ignored']),
            searchQuery: '',
            debouncedSearchQuery: ''
        });
    }

    handleStatusToggle(status) {
        this.setState(prevState => {
            const newSet = new Set(prevState.selectedStatuses);
            if (newSet.has(status)) {
                if (newSet.size <= 1) return null;
                newSet.delete(status);
            } else {
                newSet.add(status);
            }
            return {selectedStatuses: newSet};
        });
    }

    matchesSearchQuery(name, accountId, clientName) {
        const query = this.state.debouncedSearchQuery.trim().toLowerCase();
        if (query === '') return true;
        return (name || '').toLowerCase().includes(query)
            || String(accountId || '').toLowerCase().includes(query)
            || (clientName || '').toLowerCase().includes(query);
    }

    getFilteredAccounts(accounts) {
        if (!accounts) return null;
        return accounts.filter(account => {
            const matchesPlatform = this.state.selectedPlatforms.size === 0
                || this.state.selectedPlatforms.has(account.channel);
            const matchesSearch = this.matchesSearchQuery(account.name, account.account_id, account.agency_client_name);
            return matchesPlatform && matchesSearch;
        });
    }

    getFilteredIgnoredAccounts(accounts) {
        if (!accounts) return null;
        return accounts.filter(data => {
            const account = data.ad_account;
            const matchesPlatform = this.state.selectedPlatforms.size === 0
                || this.state.selectedPlatforms.has(account.channel);
            const matchesSearch = this.matchesSearchQuery(account.name, account.account_id, account.agency_client_name);
            return matchesPlatform && matchesSearch;
        });
    }

    hasActiveFilters() {
        return this.state.selectedPlatforms.size > 0
            || this.state.debouncedSearchQuery.trim() !== ''
            || this.state.selectedStatuses.size < 3;
    }

    render() {
        const filteredClientAdAccounts = this.getFilteredAccounts(this.state.clientAdAccounts);
        const filteredClientStores = this.getFilteredAccounts(this.state.clientStores);
        const filteredUnlinkedAdAccounts = this.getFilteredAccounts(this.state.unlinkedAdAccounts);
        const filteredIgnoredAdAccounts = this.getFilteredIgnoredAccounts(this.state.ignoredAdAccounts);

        return (
            <section className="section-content agency-page agency-accounts-page">
                <AgencyHeader/>
                <AgencyTabs activeTab="-third"/>
                <div className="section-body h-items">
                    <ClientAdAccountAndStoresList
                        mode={VIEW_MODE_AGENCY_ACCOUNTS}
                        afterSuccessfulClientAdAccountSubmit={this.handleClientAdAccountSuccessfullyAdded}
                        afterSuccessfulClientStoreSubmit={this.handleClientStoreSuccessfullyAdded}
                        afterSuccessfulGiveAccessClientAdAccountSubmit={this.handleGiveAccessClientAdAccountSuccessfully}
                        clientAdAccounts={filteredClientAdAccounts}
                        clientStores={filteredClientStores}
                        channels={this.state.channels}
                        unlinkedAdAccounts={filteredUnlinkedAdAccounts}
                        ignoredAdAccounts={filteredIgnoredAdAccounts}
                        unfilteredCounts={{
                            clientAdAccounts: this.state.clientAdAccounts ? this.state.clientAdAccounts.length : 0,
                            clientStores: this.state.clientStores ? this.state.clientStores.length : 0,
                            unlinkedAdAccounts: this.state.unlinkedAdAccounts ? this.state.unlinkedAdAccounts.length : 0,
                            ignoredAdAccounts: this.state.ignoredAdAccounts ? this.state.ignoredAdAccounts.length : 0
                        }}
                        unfilteredAccounts={{
                            clientAdAccounts: this.state.clientAdAccounts,
                            clientStores: this.state.clientStores,
                            unlinkedAdAccounts: this.state.unlinkedAdAccounts,
                            ignoredAdAccounts: this.state.ignoredAdAccounts
                        }}
                        selectedPlatforms={this.state.selectedPlatforms}
                        selectedStatuses={this.state.selectedStatuses}
                        searchQuery={this.state.searchQuery}
                        onPlatformToggle={this.handlePlatformToggle}
                        onSearchChange={this.handleSearchChange}
                        onStatusToggle={this.handleStatusToggle}
                        hasActiveFilters={this.hasActiveFilters()}
                        onClearFilters={this.handleClearFilters}
                        doClientAdAccountRemove={this.handleClientAdAccountRemove}
                        doClientAdAccountEdit={this.handleClientAdAccountSuccessfullyEdited}
                        doClientStoreRemove={this.handleClientAdAccountRemove}
                        doClientStoreEdit={this.handleClientStoreSuccessfullyEdited}
                        doSnoozeForever={this.handleSnoozeForever}
                        isSaving={this.state.isSaving}
                        accessManagementEnabled={this.state.accessManagementEnabled}
                        location={this.props.location}
                    />
                </div>
            </section>
        )
    }
}
